module.exports = __webpack_public_path__ + "static/thumbnail-0b8a8a886c351d521f705841db044f58.png";